import authService from '@/users/services/auth-service'
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import snacks from '@/app/services/snacks'

@Component
export default class LoginTwoFactor extends Vue {
  @Ref()
  private validator!: ValidationObserver

  private code = ''

  private email = ''

  private serverError = ''

  private loggingIn = false

  public async loginTwoFactor() {
    this.loggingIn = true

    const res = await authService.loginTwoFactorAsync({
      email: this.email,
      code: this.code,
    })

    this.loggingIn = false
  }

  private mounted() {
    this.email = this.$route.params.email
  }
}
